import React, { Component } from "react";
import TripSearch from "./TripSearch";

export default class HeaderSection extends Component {
  render() {
    return (
      <section className="banner-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <TripSearch />
            </div>
          </div>
        </div>
      </section>
    );
  }
}
